<script>
  import { Divider } from 'element-ui'
  export default {
    name:'ElDivider',
    extends:Divider
  }
</script>
